import React from 'react';
import { Tabs, Table } from 'antd';
// import classNames from 'classnames';
import type { ColumnsType } from 'antd/lib/table';
// import Dot from '@/components/Dot';
import Chart from '@/business-components/chart';
// import Tooltip from '@/components/tooltip';
import styles from './index.module.scss';

interface IFinancingScheduleProps {
  data;
}
const { TabPane } = Tabs;
const columnsCampany: ColumnsType<any> = [
  {
    title: '时间',
    dataIndex: 'financeTime',
    align: 'center',
  },
  {
    title: '轮次',
    dataIndex: 'financeRoundsName',
    align: 'center',
  },
  {
    title: '金额',
    dataIndex: 'totalFinancePriceStr',
    align: 'center',
  },
  {
    title: '投资机构',
    dataIndex: 'financeChNameListStr',
    align: 'right',
  },
];

export default function FinancingSchedule({ data }: IFinancingScheduleProps) {
  return (
    <Chart
      title={
        <span className={styles.title}>
          融资历程表
          {/*<Tooltip title="因为部分品牌方不披露金额、或者只披露模糊金额" placement="right" />*/}
        </span>
      }
      panelClassName={styles.financingScheduleChart}
    >
      <Tabs defaultActiveKey="1">
        {data?.map((item, index) => (
          <TabPane tab={item?.chName} key={index}>
            <Table
              key={index}
              columns={columnsCampany}
              dataSource={item?.list || []}
              size="middle"
              pagination={{ position: ['bottomCenter'], hideOnSinglePage: true, total: item?.list.length, pageSize: 4 }}
            />
          </TabPane>
        ))}
      </Tabs>
    </Chart>
  );
}
